import React from "react";

import { DetailsPage } from "components/app_layout/DetailsLayout";
import NoticeLists from "components/notices/NoticeLists";

export function MyNoticesPage() {
  return (
    <DetailsPage>
      <NoticeLists />
    </DetailsPage>
  );
}
